import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'shared-main-menu-item',
  standalone: true,
  hostDirectives: [
    { directive: MatTooltip, inputs: ['matTooltip: tooltip'] },
  ],
  templateUrl: './main-menu-item.component.html',
  host: {
    role: 'listitem',
    class: 'relative box-border flex items-center justify-center border-e-4 p-4 pe-3 text-primary-500 hover:cursor-pointer hover:bg-neutral-100',
    '[class]': '{ "border-e-transparent": !active(), "border-e-primary-500": active() }',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainMenuItemComponent {
  active = input<boolean>(false);

  constructor() {
    inject(MatTooltip).position = 'right';
  }
}
